export function parseVersionPayload(data: unknown): number | null {
  if (!data || typeof data !== 'object') return null
  const timestamp = (data as { timestamp?: unknown }).timestamp
  if (typeof timestamp === 'number' && Number.isFinite(timestamp) && timestamp > 0) {
    return timestamp
  }
  if (typeof timestamp === 'string' && timestamp.length > 0) {
    const parsed = Number(timestamp)
    if (Number.isFinite(parsed) && parsed > 0) return parsed
  }
  return null
}

/** True when remote build timestamp differs from the tab's current build. */
export function isVersionMismatch(
  currentTimestamp: number | null,
  remoteTimestamp: number | null,
): boolean {
  if (currentTimestamp == null || remoteTimestamp == null) return false
  return remoteTimestamp !== currentTimestamp
}
